/**
 * Spanish A1 Narrow Reading/Listening Texts
 * Conti's flooded input: multiple short texts on same theme
 * recycling target chunks for thorough processing.
 */

import type { NarrowText } from '@/types/language';

export const SPANISH_A1_NARROW_TEXTS: NarrowText[] = [
  {
    id: 'nt-es-a1-01',
    title: 'Mi Presentacion',
    body: 'Hola. Me llamo Carlos. Soy de Madrid, Espana. Tengo 25 anos y soy estudiante. Estudio espanol y frances. Mi familia es grande: tengo un hermano y una hermana. Mi padre es profesor y mi madre trabaja en un hospital. Vivo en un piso pequeno en el centro de la ciudad. Me gusta mucho leer libros y escuchar musica.',
    translation: 'Hello. My name is Carlos. I am from Madrid, Spain. I am 25 years old and I am a student. I study Spanish and French. My family is big: I have a brother and a sister. My father is a teacher and my mother works in a hospital. I live in a small apartment in the city center. I like reading books and listening to music a lot.',
    targetChunks: [
      'Me llamo', 'Soy de', 'Tengo', 'soy estudiante', 'Mi familia es',
      'tengo un', 'Mi padre es', 'Mi madre', 'Vivo en', 'Me gusta mucho',
    ],
  },
  {
    id: 'nt-es-a1-02',
    title: 'Un Dia Normal',
    body: 'Todos los dias me levanto a las siete. Desayuno pan con cafe. Luego voy a la escuela en autobus. Estudio espanol por la manana. Como a las dos en casa. Por la tarde hago la tarea y leo un libro. Por la noche ceno con mi familia. Siempre veo la tele antes de dormir. Me gusta mucho mi rutina.',
    translation: 'Every day I get up at seven. I have breakfast (bread with coffee). Then I go to school by bus. I study Spanish in the morning. I eat at home at two. In the afternoon I do homework and read a book. In the evening I have dinner with my family. I always watch TV before sleeping. I like my routine a lot.',
    targetChunks: [
      'Todos los dias', 'me levanto', 'Voy a', 'Estudio', 'Como a las',
      'hago la tarea', 'leo un libro', 'Ceno con', 'Veo la tele',
    ],
  },
  {
    id: 'nt-es-a1-03',
    title: 'Mi Familia',
    body: 'Mi familia es muy importante para mi. Mi padre se llama Jose y es alto. Mi madre se llama Ana y es muy amable. Tengo dos hermanos: un hermano mayor que se llama Pedro y una hermana pequena que se llama Lucia. Mi hermano vive en Barcelona y trabaja en un banco. Mi hermana estudia en la universidad. Mis abuelos viven cerca de casa. Cada domingo comemos todos juntos. La comida esta siempre muy buena.',
    translation: 'My family is very important to me. My father is called Jose and he is tall. My mother is called Ana and she is very kind. I have two siblings: an older brother called Pedro and a little sister called Lucia. My brother lives in Barcelona and works in a bank. My sister studies at the university. My grandparents live near home. Every Sunday we all eat together. The food is always very good.',
    targetChunks: [
      'Mi familia es', 'Mi padre se llama', 'Mi madre se llama',
      'Tengo dos', 'vive en', 'trabaja en', 'estudia en',
      'viven cerca', 'Cada domingo', 'comemos juntos',
    ],
  },
  {
    id: 'nt-es-a1-04',
    title: 'Mis Gustos',
    body: 'A mi me gusta mucho la musica. Escucho musica todos los dias. Me gusta el pop y el rock. No me gusta nada el reggaeton. A mi hermano le gusta el deporte. Juega al futbol cada sabado. A mi hermana le gusta bailar. Baila muy bien. A mis padres les gusta viajar. Viajan a lugares bonitos. A mi me gustaria viajar a Mexico. Pero primero quiero aprender bien el espanol.',
    translation: 'I like music a lot. I listen to music every day. I like pop and rock. I do not like reggaeton at all. My brother likes sports. He plays soccer every Saturday. My sister likes dancing. She dances very well. My parents like traveling. They travel to pretty places. I would like to travel to Mexico. But first I want to learn Spanish well.',
    targetChunks: [
      'A mi me gusta', 'Me gusta', 'No me gusta nada',
      'Le gusta', 'Les gusta', 'Me gustaria',
      'quiere aprender', 'muy bien',
    ],
  },
];

export default SPANISH_A1_NARROW_TEXTS;
